export const APP_IDS = Object.freeze({
  PLANY_CARE: "plany-care",
  TIMELY: "timely",
});
